import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      // route level code-splitting
      // this generates a separate chunk (unauthorized.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('@/components/Dashboard.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/languages',
      name: 'Languages',
      component: () => import('@/components/Languages.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/events',
      name: 'Events',
      component: () => import('@/components/Events.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/events/:id/',
      name: 'Event',
      component: () => import('@/components/Event.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/events/:id/:clone',
      name: 'EventClone',
      component: () => import('@/components/Event.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/password',
      name: 'Password',
      component: () => import('@/components/Password.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/settings',
      name: 'Settings',
      component: () => import('@/components/Settings.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/upgrade',
      name: 'Upgrade',
      component: () => import('@/components/Upgrade.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/support',
      name: 'Support',
      component: () => import('@/components/Support.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/components/Login.vue'),
      meta: {
        guest: true,
      },
    },
    {
      path: '/password-reset/:token',
      name: 'PasswordReset',
      component: () => import('@/components/PasswordReset.vue'),
      meta: {
        guest: true,
      },
    },
    {
      path: '/account-unlock/:token',
      name: 'AccountUnlock',
      component: () => import('@/components/AccountUnlock.vue'),
      meta: {
        guest: true,
      },
    },
    {
      path: '/unsubscribe/:token',
      name: 'Unsubscribe',
      component: () => import('@/components/Unsubscribe.vue'),
      meta: {
        guest: true,
      },
    },
    {
      path: '*',
      component: () => import('@/views/NotFound.vue'),
    },
    {
      path: '/browser-not-supported',
      component: () => import('@/views/BrowserNotSupported.vue'),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // Returning the savedPosition will result in a native-like behavior
      // when navigating with back/forward buttons:
      return savedPosition
    } else {
      // This will simply make the page scroll to top for all route navigations.
      return { x: 0, y: 0 }
    }
  },
})
